import React from 'react'

function Footer () {

  return (
    <footer>
      <a href="https://www.kiertokapula.fi/yhteystiedot/anna-palautetta/" target="a_blank">Anna palautetta</a>
      <a href="https://www.kiertokapula.fi/palvelut/jatteiden-vastaanotto/hinnasto/" target="a_blank">Hinnoittelu</a>
      <a href="https://www.kiertokapula.fi/yhteystiedot/" target="a_blank">Yhteystiedot</a>
    </footer>
    )
}

export default Footer